__turbopack_context__.v({
  "boxContentElement": "_4JlCXW_boxContentElement",
  "boxContentElementWrapper": "_4JlCXW_boxContentElementWrapper",
  "contentsList": "_4JlCXW_contentsList",
  "root": "_4JlCXW_root",
  "title": "_4JlCXW_title",
  "wrapper": "_4JlCXW_wrapper",
});
